<template>
  <v-dialog
    v-model="dialogStatus"
    width="600"
    height="60vh"
    persistent
  >
    <v-card class="pa-3">
      <v-card-title class="font-weight-light text-uppercase">
        <v-icon class="mr-2">
          person
        </v-icon>
        Create Party
        <v-spacer />

        <v-btn
          icon
          @click="closeDialog"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-radio-group
        v-model="newOrExisting"
        row
      >
        <v-radio
          :label="'Create new record' + (newParty ? ' for ' + newParty : '')"
          value="new"
        />
        <v-radio
          :label="addToExistingRecordText"
          value="existing"
        />
      </v-radio-group>

      <template v-if="newOrExisting === 'existing'">
        <v-autocomplete
          v-model="selectedRecord"
          filled
          clearable
          hide-selected
          :rules="[rules.required]"
          :items="records"
          label="Records"
          @change="updateSelectedRecord"
        />
        <v-autocomplete
          v-model="selectedCase"
          filled
          clearable
          hide-selected
          no-data-text="Select at least one record to find Cases"
          :rules="[rules.required]"
          :items="cases"
          label="Cases"
          @change="updateSelectedCase"
        />
      </template>

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          color="secondary"
          @click="closeDialog"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          :disabled="!isValid"
          @click="submitCreate"
        >
          Continue
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { partyName } from '@/utilities'
import { rules } from '@/utilities/validation-rules'

// NOTE: for now, this will allow only one record and one case selection.
// The API could be updated to accept multiple, and this could then select multiple.

export default {
  name: 'DialogSelectRecordCase',

  props: {
    newParty: {
      type: String,
      default: null,
    },

    party: {
      type: Object,
      required: true,
    },

    status: {
      type: Boolean,
      required: true,
    },
  },

  data () {
    return {
      newOrExisting: '',
      rules: rules,
      selectedCase: '',
      selectedRecord: '',
    }
  },

  computed: {

    addToExistingRecordText () {
      return `Add to existing record ${partyName(this.party)} belongs to`
    },

    cases () {
      const availableCases = []
      this.party.records.forEach(r => {
        if (this.selectedRecord === r.id) {
          r.legal_cases.forEach(c => {
            availableCases.push({ text: c.label + ' (' + c.attorney + ')', value: c.id })
          })
        }
      })
      return availableCases
    },

    dialogStatus () {
      return this.status
    },

    isValid () {
      let valid = false
      if (this.newOrExisting === 'new') valid = true
      else if (this.newOrExisting === 'existing') if (this.selectedRecord && this.selectedCase) valid = true

      return valid
    },

    records () {
      return this.party.records.map(r => {
        const label = '#' + r.id + ' ' + r.record_holder
        return { text: label, value: r.id }
      })
    },
  },

  methods: {
    closeDialog () {
      this.$emit('close')
    },

    submitCreate () {
      if (this.newOrExisting === 'new') this.$emit('continue', { new: true })
      else if (this.newOrExisting === 'existing') this.$emit('continue', { case: this.selectedCase, new: false, record: this.selectedRecord })

      this.$emit('close')
    },

    updateSelectedCase (selected) {
      this.selectedCase = selected
    },

    updateSelectedRecord (selected) {
      this.selectedRecord = selected
    },
  },
}
</script>
